import $ from 'jquery';
import _ from 'underscore';

import { StickyElement } from './sticky-element';

export class StickyOverview {
  constructor(options = {}) {
    this.$sticky = new StickyElement(options.$el);
    this.$document = $(document);

    this.onScroll = _.throttle(this.onScroll, 16).bind(this);
  }

  init() {
    if (this.$sticky.isStickyElementSmallerThanAnchor()) {
      this.$sticky.init();
      this.bindScrollListener();
    }
  }

  onScroll() {
    const scrollTop = this.$document.scrollTop();
    const {
      stickElementHeight,
      anchorElementHeight,
      topOffset
    } = this.$sticky.position;

    if (scrollTop < topOffset) {
      return this.$sticky.emit('unstick');
    }

    const limit = anchorElementHeight - stickElementHeight + topOffset;

    if (scrollTop >= topOffset && scrollTop <= limit) {
      return this.$sticky.emit('top');
    }

    return this.$sticky.emit('bottom');
  }

  bindScrollListener() {
    $(window).on('scroll', this.onScroll);
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/layout/sticky-overview/sticky-overview.js
 **/